// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606161520/js/" + chunkId + "." + {"44":"60d8912b","225":"8ce1d28d","481":"76b19480","486":"4c103b2d","770":"51ec97aa"}[chunkId] + ".0.6713651240317484.chunk.js";
};